import * as moment from "moment";
import NotificationBase from "../NotificationBase";
import {NotificationBaseApiDto, SmsNotificationDataApiDto} from "../../../api/model/rest";
import SmsNotificationData from "./SmsNotificationData";

/**
 * Sms notification class.
 */
export default class SmsNotification extends NotificationBase {
	/**
	 * @param {string} id notification id.
	 * @param {moment.Moment} visibleFrom Notification datetime.
	 * @param {boolean} read flag if sms is marked as read.
	 * @param {string} type in this case always 'SMS_RECEIVED'.
	 * @param {SmsNotificationData} data sms notification data object.
	 */
	constructor(readonly id: string,
		readonly visibleFrom: moment.Moment,
		readonly read: boolean,
		readonly type: string,
		readonly data: SmsNotificationData) {
		super(id, visibleFrom, read, type);
	}

	static fromJson(json: NotificationBaseApiDto): SmsNotification {
		return new SmsNotification(json.id, moment(json.visibleFrom), json.read, json.type,
			SmsNotificationData.fromJson(json.data as SmsNotificationDataApiDto));
	}

	displayCreatorName() {
		return this.data.recognizedSmsData.map(rsd => rsd.contactFullName).getOrElse(this.data.phoneNumber);
	}

	copy({id = this.id, dateTime = this.visibleFrom, read = this.read, type = this.type, data = this.data}) {
		return new SmsNotification(id, dateTime, read, type, data);
	}
}